import { render, staticRenderFns } from "./IconAttachment.vue?vue&type=template&id=73de5871&scoped=true&"
var script = {}
import style0 from "./IconAttachment.vue?vue&type=style&index=0&id=73de5871&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73de5871",
  null
  
)

export default component.exports